import React from 'react';
import { Typography, Space, Layout, Divider } from 'antd';

const { Title, Paragraph, Text } = Typography;
const { Content } = Layout;

const TermsOfServicePage: React.FC = () => {
  return (
    <Layout style={{ minHeight: '100vh', padding: '24px' }}>
      <Content style={{ background: '#fff', padding: '24px', borderRadius: '8px', maxWidth: '800px', margin: '0 auto' }}>
        <Typography>
          <Title level={1} style={{ textAlign: 'center' }}>Terms of Service</Title>
          <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: '24px' }}>
            Effective Date: April 4, 2025
          </Text>

          <Divider />

          <Title level={2}>1. Acceptance of Terms</Title>
          <Paragraph>
            By accessing or using Flow Learning ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.
          </Paragraph>

          <Title level={2}>2. Description of Service</Title>
          <Paragraph>
            Flow Learning provides a platform for creating, sharing, and exploring learning flows and knowledge maps. The Service may include various features and functionalities that allow users to organize and connect information in meaningful ways.
          </Paragraph>

          <Title level={2}>3. User Accounts</Title>
          <Paragraph>
            To use certain features of the Service, you must create an account using Single Sign-On (SSO) through supported providers. You are responsible for maintaining the confidentiality of your account and for all activities that occur under your account.
          </Paragraph>
          <Paragraph>
            You agree to:
          </Paragraph>
          <ul>
            <li>Provide accurate and complete information when creating your account.</li>
            <li>Update your information as necessary to keep it current.</li>
            <li>Notify us immediately of any unauthorized use of your account or any other breach of security.</li>
          </ul>

          <Title level={2}>4. User Content</Title>
          <Paragraph>
            You retain ownership of any content you create, upload, or share through the Service ("User Content"). By submitting User Content, you grant Flow Learning a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, adapt, publish, translate, and distribute your User Content in connection with the Service.
          </Paragraph>
          <Paragraph>
            You represent and warrant that:
          </Paragraph>
          <ul>
            <li>You own or have the necessary rights to your User Content.</li>
            <li>Your User Content does not violate the rights of any third party, including intellectual property rights and privacy rights.</li>
            <li>Your User Content does not violate any applicable laws or regulations.</li>
          </ul>

          <Title level={2}>5. Prohibited Conduct</Title>
          <Paragraph>
            You agree not to:
          </Paragraph>
          <ul>
            <li>Use the Service for any illegal purpose or in violation of any laws.</li>
            <li>Post or transmit harmful, threatening, abusive, harassing, defamatory, or otherwise objectionable content.</li>
            <li>Impersonate any person or entity or falsely state or misrepresent your affiliation with a person or entity.</li>
            <li>Interfere with or disrupt the Service or servers or networks connected to the Service.</li>
            <li>Attempt to gain unauthorized access to any part of the Service.</li>
            <li>Use the Service to send unsolicited communications or advertisements.</li>
            <li>Collect or harvest user information without their consent.</li>
          </ul>

          <Title level={2}>6. Intellectual Property</Title>
          <Paragraph>
            The Service and its original content, features, and functionality are owned by Flow Learning and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
          </Paragraph>

          <Title level={2}>7. Termination</Title>
          <Paragraph>
            We may terminate or suspend your account and access to the Service immediately, without prior notice or liability, for any reason, including if you breach these Terms of Service.
          </Paragraph>

          <Title level={2}>8. Disclaimer of Warranties</Title>
          <Paragraph>
            The Service is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not warrant that the Service will be uninterrupted or error-free, that defects will be corrected, or that the Service is free of viruses or other harmful components.
          </Paragraph>

          <Title level={2}>9. Limitation of Liability</Title>
          <Paragraph>
            In no event shall Flow Learning be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, data, or goodwill, arising out of or in connection with your access to or use of the Service.
          </Paragraph>

          <Title level={2}>10. Changes to Terms</Title>
          <Paragraph>
            We reserve the right to modify or replace these Terms of Service at any time. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
          </Paragraph>

          <Title level={2}>11. Governing Law</Title>
          <Paragraph>
            These Terms shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.
          </Paragraph>

          <Title level={2}>12. Contact Information</Title>
          <Paragraph>
            If you have any questions about these Terms, please contact us at:
          </Paragraph>
          <Paragraph>
            Email: <a href="mailto:flow-learning@example.com">flow-learning@example.com</a>
          </Paragraph>

          <Divider />
          <Paragraph style={{ textAlign: 'center' }}>
            &copy; 2025 Flow Learning. All rights reserved.
          </Paragraph>
        </Typography>
      </Content>
    </Layout>
  );
};

export default TermsOfServicePage;